import reducer from "./reducer";

import * as loaderSelectors from "./selectors";
import * as loaderOperations from "./operations";
import * as loaderTypes from "./types";

export { loaderSelectors, loaderOperations, loaderTypes };

export default reducer;
